import store_rendez_vous from '@/store/mods/clinique/rendez_vous'
import PriseRendezVous from '@/components/rendez-vous/prise-rendez-vous'
import FixerHeureRendezVous from '@/components/rendez-vous/fixer-heure-rendez-vous'   // RDV-006
import { date_lisible, date_rdv_lisible, heure_a_fixer_possible, message_erreur } from '@/utils/rendez-vous'

// RDV-002 : bloc « Prochain rendez-vous » de la fiche patient à l'Accueil (aucune impression) : prochain rendez-vous actif,
// rendez-vous à venir et passés, prise directe, reprogrammation et annulation motivée.
// RDV-006 : un rendez-vous donné sans heure affiche « jour · heure à fixer » (jamais 00:00) et propose « Fixer l'heure ».
export default {
    name: 'prochain-rendez-vous',
    components: { PriseRendezVous, FixerHeureRendezVous },
    props: {
        patient_id: { type: Number, default: 0 },
        patient_nom: { type: String, default: '' },
        compact: { type: Boolean, default: false }   // dans la carte du bon de consultation : bloc réduit
    },
    data() {
        return {
            donnees: null, is_loading: false, erreur: '', info: '', sequence: 0, detruit: false,
            voir_autres: false,
            prise_toggler: 0, prise_rendez_vous: null,
            fixer_toggler: 0, fixer_rendez_vous: null,
            annulation: false, motif_annulation: '', is_saving: false, erreur_annulation: ''
        }
    },

    watch: {
        patient_id() {
            this.annulation = false
            this.voir_autres = false
            this.charger()
        }
    },

    computed: {
        prochain() {
            return this.donnees && this.donnees.prochain ? this.donnees.prochain : null
        },

        autres_a_venir() {
            const liste = this.donnees && Array.isArray(this.donnees.a_venir) ? this.donnees.a_venir : []
            return liste.filter((rdv, index) => index > 0)
        },

        passes() {
            return this.donnees && Array.isArray(this.donnees.passes) ? this.donnees.passes : []
        },

        aujourd_hui() {
            return !!(this.donnees && this.donnees.aujourd_hui)
        },

        // RDV-006 : rendez-vous planifié sans heure dont le jour n'est pas passé ; la Clinique vérifie le rôle
        peut_fixer_heure() {
            return heure_a_fixer_possible(this.prochain)
        }
    },

    mounted() {
        this.charger()
    },

    beforeDestroy() {
        this.detruit = true
        this.sequence++
    },

    methods: {
        charger() {
            if (this.detruit) return Promise.resolve()
            const sequence = ++this.sequence
            if (!this.patient_id) {
                this.donnees = null
                return Promise.resolve()
            }
            this.is_loading = true
            this.erreur = ''
            return store_rendez_vous.getProchainPatient(this.patient_id).then((response) => {
                if (this.detruit || sequence !== this.sequence) return
                if (!response || !response.success || !response.data) throw new Error('Réponse invalide')
                this.donnees = response.data
                this.is_loading = false
            }).catch((error) => {
                if (this.detruit || sequence !== this.sequence) return
                this.donnees = null
                this.is_loading = false
                this.erreur = message_erreur(error, 'Impossible de charger les rendez-vous du patient.')
            })
        },

        ouvrir_prise() {
            this.prise_rendez_vous = null
            this.info = ''
            this.prise_toggler = (this.prise_toggler === 0) ? 1 : 0
        },

        ouvrir_reprogrammation() {
            if (!this.prochain) return
            this.prise_rendez_vous = this.prochain
            this.info = ''
            this.prise_toggler = (this.prise_toggler === 0) ? 1 : 0
        },

        apres_prise(resultat) {
            this.info = resultat && resultat.message ? resultat.message : 'Rendez-vous enregistré.'
            this.$emit('emitRendezVousModifie', resultat)
            return this.charger()
        },

        ouvrir_annulation() {
            if (!this.prochain) return
            this.motif_annulation = ''
            this.erreur_annulation = ''
            this.annulation = true
        },

        confirmer_annulation() {
            if (this.is_saving || !this.prochain) return Promise.resolve()
            if (!this.motif_annulation.trim()) {
                this.erreur_annulation = 'Indiquez le motif de l\'annulation.'
                return Promise.resolve()
            }
            this.is_saving = true
            this.erreur_annulation = ''
            const rendez_vous_id = this.prochain.rendez_vous_id
            return store_rendez_vous.changerStatut(rendez_vous_id, { statut: 'annule', motif: this.motif_annulation.trim() }).then((response) => {
                if (this.detruit) return
                if (!response || response.success !== true) throw new Error('Annulation refusée')
                this.is_saving = false
                this.annulation = false
                this.info = response.message || 'Rendez-vous annulé.'
                this.$emit('emitRendezVousModifie', response)
                return this.charger()
            }).catch((error) => {
                if (this.detruit) return
                this.is_saving = false
                this.erreur_annulation = message_erreur(error, 'L\'annulation n\'a pas été enregistrée. Actualisez puis réessayez.')
            })
        },

        date_heure(locale) {
            return date_lisible(locale)
        },

        // « 25/09/2026 09:30 », ou « jeudi 01/10/2026 · heure à fixer »
        date_rdv(ligne) {
            return date_rdv_lisible(ligne)
        },

        ouvrir_fixer_heure() {
            if (!this.peut_fixer_heure) return
            this.fixer_rendez_vous = this.prochain
            this.info = ''
            this.fixer_toggler = (this.fixer_toggler === 0) ? 1 : 0
        },

        apres_fixation(rendez_vous, reponse) {
            this.info = reponse && reponse.message ? reponse.message : 'Heure fixée.'
            this.$emit('emitRendezVousModifie', reponse)
            return this.charger()
        }
    }
}
